var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"bg_payment",style:(_vm.bg_payment)},[_c('v-main',{staticClass:"sticker_turminha",style:(_vm.sticker_turminha)},[_c('Container')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }